import React, { Fragment } from 'react';
import { Container } from 'theme-ui';

const LayoutWrapper = ({ children, divider, addToLast = true }) => {
  const blocks = React.Children.toArray(children);
  return (
    <Container variant='container'>
      {blocks.map((block, index) => {
        if (!addToLast && blocks.length - 1 === index) {
          return child;
        }
        return (
          <Fragment key={index}>
            {block}
            {divider}
          </Fragment>
        );
      })}
    </Container>
  );
};

export default LayoutWrapper;
